import { SystemCode } from '../models/systemCode';
/**
 * @description Determines the system code based on the registration source (rs) parameter.
 * The mapping is as follows:
 * - If rs is 'qrcode', return 'DandG_QRR'
 * - If rs is 'photoregister', return 'DandG_PPR'
 * - If rs is 'qr', return 'DandG_QRN'
 * - If rs is 'qrinsert', return 'DandG_QRI'
 * - For any other value of rs (including undefined), return 'DandG_IPR'
 *
 * See image in https://domgen.atlassian.net/browse/UEO-785
 *
 * @param {string | undefined}  rs - The registration source parameter from the URL
 * @return {string} - The corresponding system code based on the mapping rules
 * @example
 *
 * ````typescript
 * getSystemCode('qrcode'); // returns 'DandG_QRR'
 * getSystemCode('qr'); // returns 'DandG_QRN'
 * getSystemCode('qrinsert'); // returns 'DandG_QRI'
 *
 * getSystemCode('photoregister'); // returns 'DandG_PPR'
 * getSystemCode('someOtherValue'); // returns 'DandG_IPR'
 * ````
 */
const systemCodesSource = new Map<string, SystemCode>([
  ['qrcode', 'DandG_QRR'],
  ['qr', 'DandG_QRN'],
  ['qrinsert', 'DandG_QRI'],
  ['photoregister', 'DandG_PPR'],
]);

export function getSystemCode(rs?: string): SystemCode {
  return (rs && systemCodesSource.get(rs)) || 'DandG_IPR';
}
